import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useMultiStyleConfig, HStack, Box, ButtonGroup, Button, CloseButton } from '@chakra-ui/react';
import { Icon } from '../components/Icon/component.js';
import { Typography } from '../components/Typography/component.js';

var Alert = function Alert(_ref) {
  var variant = _ref.variant,
      title = _ref.title,
      description = _ref.description,
      actions = _ref.actions,
      isClosable = _ref.isClosable,
      onClose = _ref.onClose,
      showIcon = _ref.showIcon;
  var variantToIcon = {
    success: {
      prefix: 'fas',
      iconName: 'check-circle'
    },
    error: {
      prefix: 'fas',
      iconName: 'octagon-exclamation'
    },
    info: {
      prefix: 'fas',
      iconName: 'info-circle'
    },
    warning: {
      prefix: 'fas',
      iconName: 'exclamation-triangle'
    },
    neutral: {
      prefix: 'far',
      iconName: 'bell'
    }
  };
  /**
   * Hooks
   */

  var styles = useMultiStyleConfig('Alert', {
    variant: variant
  });
  /**
   * DOM
   */

  return /*#__PURE__*/React.createElement(HStack, {
    "data-object-type": "alert",
    align: "flex-start",
    __css: styles.container,
    display: "inline-flex"
  }, showIcon && /*#__PURE__*/React.createElement(Box, {
    __css: styles.icon,
    mr: "2",
    mt: "1"
  }, /*#__PURE__*/React.createElement(Icon, _extends({}, variantToIcon[variant], {
    size: 'lg'
  }))), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Box, {
    __css: styles.title
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: 'h4'
  }, title)), /*#__PURE__*/React.createElement(Box, {
    __css: styles.description
  }, /*#__PURE__*/React.createElement(Typography, {
    textStyle: 'p2'
  }, description)), ((actions === null || actions === void 0 ? void 0 : actions.primary) || (actions === null || actions === void 0 ? void 0 : actions.secondary)) && /*#__PURE__*/React.createElement(ButtonGroup, {
    spacing: '2',
    mt: '3',
    colorScheme: 'gray'
  }, actions.primary && /*#__PURE__*/React.createElement(Button, {
    variant: 'solid',
    onClick: actions.primary.onClick
  }, actions.primary.label), actions.secondary && /*#__PURE__*/React.createElement(Button, {
    variant: 'outline',
    onClick: actions.secondary.onClick
  }, actions.secondary.label))), isClosable && /*#__PURE__*/React.createElement(CloseButton, {
    size: 'sm',
    onClick: onClose
  }));
};

Alert.displayName = "Alert";
export { Alert };